export enum TeamOptionsFilter {
    Away = 'Away',
    Home = 'Home'
}
